// Lightweight client-side metrics store for feedback capture
// Tracks visited URLs and recent console errors/warnings

const state = {
  visitedUrls: [],
  consoleLogs: [], // { level: 'error'|'warn', message, timestamp }
  installed: false,
};

const MAX_LOGS = 200;

export function installMetricsCapture() {
  if (state.installed) return;
  state.installed = true;

  // Capture console errors and warnings
  try {
    const originalError = window.console.error;
    const originalWarn = window.console.warn;

    window.console.error = function (...args) {
      try {
        state.consoleLogs.push({
          level: 'error',
          message: serializeArgs(args),
          timestamp: new Date().toISOString(),
        });
        if (state.consoleLogs.length > MAX_LOGS) {
          state.consoleLogs.splice(0, state.consoleLogs.length - MAX_LOGS);
        }
      } catch {}
      originalError && originalError.apply(window.console, args);
    };

    window.console.warn = function (...args) {
      try {
        state.consoleLogs.push({
          level: 'warn',
          message: serializeArgs(args),
          timestamp: new Date().toISOString(),
        });
        if (state.consoleLogs.length > MAX_LOGS) {
          state.consoleLogs.splice(0, state.consoleLogs.length - MAX_LOGS);
        }
      } catch {}
      originalWarn && originalWarn.apply(window.console, args);
    };
  } catch {}
}

export function trackVisitedUrl(url) {
  if (!url) return;
  const last = state.visitedUrls[state.visitedUrls.length - 1];
  if (last !== url) {
    state.visitedUrls.push(url);
    if (state.visitedUrls.length > 500) {
      state.visitedUrls.splice(0, state.visitedUrls.length - 500);
    }
  }
}

export function getFeedbackContext() {
  return {
    current_url: window.location.href,
    visited_urls: [...state.visitedUrls],
    console_logs: [...state.consoleLogs],
    user_agent: navigator.userAgent,
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    language: navigator.language,
    platform: navigator.platform,
    referrer: document.referrer || null,
  };
}

function serializeArgs(args) {
  try {
    return args.map(a => {
      if (a instanceof Error) {
        return `${a.name}: ${a.message}\n${a.stack}`;
      }
      if (typeof a === 'object') {
        return JSON.stringify(a);
      }
      return String(a);
    }).join(' ');
  } catch {
    try {
      return args.map(String).join(' ');
    } catch {
      return 'unserializable';
    }
  }
}
